import './styles.css';

import {
    ActionBar,
    ActionBarRow,
    DynamicRangeFilter,
    GroupedSelectedFilters,
    HierarchicalMenuFilter,
    Hits,
    HitsStats,
    InputFilter,
    Layout,
    LayoutBody,
    LayoutResults,
    NoHits,
    NumericRefinementListFilter,
    Pagination,
    RefinementListFilter,
    ResetFilters,
    SearchBox,
    SearchkitManager,
    SearchkitProvider,
    SideBar,
    SortingSelector,
    TopBar,
    ViewSwitcherToggle
} from 'searchkit';
import React, {Component} from 'react';

//import './index.css'



const envs = {
    FEA_BASE_URL     : process.env.REACT_APP_FEA_BASE_URL || 'https://www.frenchestateagents.com',
    LEGGETT_BASE_URL : process.env.REACT_APP_LEGGETT_BASE_URL || 'https://www.leggett-immo.com'
};

const searchkit = new SearchkitManager(process.env.REACT_APP_ELASTIC_HOST, { basicAuth : process.env.REACT_APP_ELASTIC_BASIC_AUTH });

const PropertyHitsGridItem = (props) => {

    const { result } = props;
    const source     = Object.assign({}, result._source, result.highlight);
    let url          = `${ envs.FEA_BASE_URL }/french-property-for-sale/view/${ source.propref }`;
    let imgUrl       = source.image_0_thumb_200 || source.image_0_thumb_400 || source.image_0_thumb_800 || source.image_0_thumb_100;
    let title        = `French property, houses and homes for sale in ${ source.pubtown } ${ source.department_name } ${ source.region_name } France by the French estate agents`;

    if (source.habitable_m2 == null) {
        source.habitable_m2 = 0;
    }

    return (
        <div className="thumbwrapper">
            <div className="thumbnail picbox">
                <a href={ url }><img
                    src={ imgUrl }
                    alt="French property for sale "
                    title= { title }
                    className="group list-group-image" style={ { width : '250px', height : '189px' } }/></a>
                <div className="ref_banner">REF: { source.propref }</div>
                <div className="listing">
                    <div className="outline truncate">
                        <h4 className="group inner list-group-item-heading"
                            dangerouslySetInnerHTML={ { __html : source.primarypropertytype_name + ' ' + source.department_name } }/>
                        <p className="group inner list-group-item-text">
                            <strong dangerouslySetInnerHTML={ { __html : source.propname } }></strong>
                            <br/>
                        </p>
                    </div>
                    <div className="places">
                        <p>Region : <span dangerouslySetInnerHTML={ { __html : source.region_name } }></span></p>
                        <p>Near:
                            <span className="town">
                                <a href={ `${ envs.FEA_BASE_URL }/french-property-for-sale/pubtown/${ result._source.pubtown }` } id="61410"
                                    style={ { textDecoration : 'underline !important' } } title="" aria-describedby="ui-tooltip-8"
                                    dangerouslySetInnerHTML={ { __html : source.pubtown } }
                                />																													
                            </span>
                        </p>
                    </div>
                    <div>
                        <div className="money price">
                            <span>€</span>
                            <span>{ source.price }</span>
                            <br/>&nbsp;
                        </div>
                    </div>
                    <div className="prow">
                        <div className="plistm">
                            <img
                                src={ `${ envs.FEA_BASE_URL }/img/region_area/${ source.region_id }.gif` }
                                alt="areamap"/>
                        </div>
                        <div className="plist">
                            <div className="inner">
                                <p><span>{ `${ source.land_m2 } M²` } </span>land</p>
                            </div>
                        </div>
                        <div className="plist">
                            <div className="inner">
                                <p><span>{ `${ source.habitable_m2 } M²` }</span>size</p>
                            </div>
                        </div>
                        <div className="plist">
                            <div className="inner">
                                <p><img src={ `${ envs.FEA_BASE_URL }/img/new_nov_v1/bed.png` } alt="bed"  style={ { width : '20px', height : '15px' } }/></p>
                                <p>{ source.nrbedrooms + ' beds' }</p>
                            </div>
                        </div>
                        <div className="plist">
                            <div className="inner">
                                <p><img src={ `${ envs.FEA_BASE_URL }/img/new_nov_v1/drop.png` } alt="bathroom" style={ { width : '20px', height : '15px' } }/></p>
                                <p>{ `${ source.nrbathrooms } baths` } </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const doSearch = (query, options) => {

    return {
        bool: {
            should: [
                {simple_query_string: {query, fields: ["_all"]}},
                {
                    multi_match: {
                        query,
                        type: "bool_prefix",
                        fields: [
                            "pubtown^1",
                            "postcode^1",
                            "department_name^2",
                            "region_name",
                            "propname^10",
                            "primarypropertytype_name^10",
                            "propref^10"
                        ]
                    }
                }
            ]
        }
    }
}

class App extends Component {
    render() {
        return (
            <SearchkitProvider searchkit={ searchkit }>
                <Layout>
                    <TopBar>
                        <div className="logo"><a href='/'><img
                            src={ `${ envs.LEGGETT_BASE_URL }/img/logo/logo-leggett-immobilier-international.svg` }
                            className="img-responsive img-logo"
                            /></a></div>
                        <SearchBox autofocus={ true } searchOnChange={ true } queryBuilder={ doSearch }/>
                    </TopBar>

                    <LayoutBody>

                        <SideBar>
                            <HierarchicalMenuFilter fields={ ['region_name.keyword', 'department_name.keyword'] }
                                                    title="Areas" id="areas"/>
                            <DynamicRangeFilter field="metaScore" id="metascore" title="Metascore"
                                                rangeFormatter={ (count) => count + '*' }/>
                            <InputFilter id="pubtown" searchThrottleTime={ 500 } title="Town" placeholder="Search Town"
                                         searchOnChange={ true } queryFields={ ['pubtown'] }/>
                            <NumericRefinementListFilter id="price" title="Price" field="price" options={ [
                                { title : 'All' },
                                { title : 'up to 50k', from : 0, to : 50000 },
                                { title : '50 to 100k', from : 50001, to : 100000 },
                                { title : '100 to 200k', from : 100001, to : 200000 },
                                { title : '200 to 300k', from : 200001, to : 300000 },
                                { title : '300 to 500k', from : 300001, to : 5000000 },
                                { title : '501 to 1M', from : 500001, to : 1000000 },
                                { title : '1M +', from : 1000001, to : 100000000 }
                            ] }/>
                            <hr/>
                            <hr/>
                            <RefinementListFilter id="region_name" title="Region" field="region_name.keyword"
                                                  operator="OR" size={ 10 }/>
                            <hr/>
                            <RefinementListFilter translations={ {
                                'facets.view_all'  : 'tout voir',
                                'facets.view_more' : 'voir plus',
                                'facets.view_less' : 'voir moins'
                            } } id="department_name" title="Department" field="department_name.keyword" operator="OR"
                                                  size={ 10 }/>
                            <hr/>
                            <RefinementListFilter id="primarypropertytype_name" title="Type"
                                                  field="primarypropertytype_name.keyword" operator="OR"
                                                  translations={ {
                                                      'facets.view_all'  : 'View All',
                                                      'facets.view_more' : 'voir plus',
                                                      'facets.view_less' : 'voir moins'
                                                  } }/>
                            <hr/>
                            <NumericRefinementListFilter id="bedrooms" title="Bedrooms" field="nrbedrooms" options={ [
                                { title : 'Tout' },
                                { title : '1-2', from : 0, to : 2 },
                                { title : '3-4', from : 3, to : 4 },
                                { title : '5-10', from : 5, to : 10 },
                                { title : '10 +', from : 10, to : 300000 }
                            ] }/>
                            <hr/>
                            <NumericRefinementListFilter id="land_m2" title="Land" field="land_m2" options={ [
                                { title : 'tout' },
                                { title : '0', from : 0, to : 0 },
                                { title : '1 to 100', from : 1, to : 100 },
                                { title : '200 to 1000', from : 201, to : 1000 },
                                { title : '1000 to 5000', from : 1001, to : 5000 },
                                { title : '5000 to 10000', from : 5001, to : 10000 },
                                { title : '10000 to 100000', from : 100001, to : 1000000 },
                                { title : '1000001 +', from : 1000001, to : 100000000 }
                            ] }/>
                        </SideBar>
                        <LayoutResults>
                            <ActionBar>

                                <ActionBarRow>
                                    <HitsStats translations={ {
                                        'hitstats.results_found' : '{hitCount} results found'
                                    } }/>
                                    <ViewSwitcherToggle/>
                                    <SortingSelector options={ [
                                        { label : 'Relevance', field : '_score', order : 'desc' },
                                        { label : 'Price Low', field : 'price', order : 'asc' },
                                        { label : 'Price High', field : 'price', order : 'desc' },
                                        { label : 'Latest Additions', field : 'date_made_live', order : 'desc' },
                                        { label : 'Oldest Additions', field : 'date_made_live', order : 'asc' }
                                    ] }/>
                                </ActionBarRow>

                                <ActionBarRow>
                                    <GroupedSelectedFilters/>
                                    <ResetFilters/>
                                </ActionBarRow>

                            </ActionBar>
                            <Hits mod="sk-hits-grid"
                                  itemComponent={ PropertyHitsGridItem }
                                  hitsPerPage={ 50 }
                                  highlightFields={ ['propname', 'pubtown'] }
                                  sourceFilter={ [
                                      'propref',
                                      'propname',
                                      'property_id',
                                      'image_0',
                                      'image_0_thumb_200',
                                      'image_0_thumb_400',
                                      'image_0_thumb_800',
                                      'image_0_thumb_100',
                                      'department_name',
                                      'region_name',
                                      'pubtown',
                                      'nrbedrooms',
                                      'nrbathrooms',
                                      'region_id',
                                      'price',
                                      'land_m2',
                                      'habitable_m2',
                                      'primarypropertytype_name'
                                  ] }
                                  hitComponents={ [
                                      {
                                          key           : 'grid',
                                          title         : 'Grid',
                                          itemComponent : PropertyHitsGridItem,
                                          defaultOption : true
                                      }
                                  ] }
                                  scrollTo="body"
                            />
                            <NoHits suggestionsField={ 'pubtown' }/>
                            <Pagination showNumbers={ true }/>
                        </LayoutResults>

                    </LayoutBody>
                </Layout>
            </SearchkitProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// /src/App.js